import { createSelector } from '@reduxjs/toolkit';
import { portalAuthenticationApiSlice } from './partner-port-authentication-api-slice';
import { portalApiSlice } from './partner-portal-api-slice';

const selectPartnerAccountInviteListResult =
    portalAuthenticationApiSlice.endpoints.getPartnerAccountInviteList.select();
const selectPartnerAccountListResult = portalAuthenticationApiSlice.endpoints.getPartnerAccountList.select();
const selectPartnerIntegrationDetailsResult = portalApiSlice.endpoints.getPartnerIntegrationDetails.select();

export const selectPartnerAccountInviteList = createSelector(selectPartnerAccountInviteListResult, ({ data }) => data);
export const selectPartnerAccountList = createSelector(selectPartnerAccountListResult, ({ data }) => data);
export const selectPartnerIntegrationDetails = createSelector(
    selectPartnerIntegrationDetailsResult,
    ({ data }) => data,
);
